module.exports = __webpack_public_path__ + "media/Great_grandson.e5bf5ab8.mp3";